import TcInfiniteScroll from "./Infinite.vue";

export default TcInfiniteScroll;
